import Kalkulator from "./KalkulatorMaterialowZPlanu"

function App() {
  return (
    <div>
      <Kalkulator />
    </div>
  );
}

export default App;
